import { useTranslation } from 'react-i18next';

type SupportedLang = 'fr' | 'es';

interface WithTranslations {
  translations?: {
    fr?: Record<string, string | undefined>;
    es?: Record<string, string | undefined>;
  };
}

/**
 * Returns the translated value for a field from a Firestore document.
 * Falls back to the default (EN) value if no translation is available.
 */
export function useLocalizedField() {
  const { i18n } = useTranslation();
  const lang = i18n.language as SupportedLang;

  function getField<T extends WithTranslations>(
    item: T,
    fieldKey: string,
    defaultValue: string
  ): string {
    if (lang !== 'fr' && lang !== 'es') return defaultValue;
    const translated = item.translations?.[lang]?.[fieldKey];
    return translated || defaultValue;
  }

  return { getField, lang };
}
